<template>
    <div id="login">
        <div class="login-container">
            <div class="login-left-bg">
                <h1>欢迎使用<br>GBU客户关系管理系统</h1>
                <img
                    src="@/assets/images/loginBg.png"
                    alt=""
                >
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>

</script>
<style lang="scss" scoped>
#login {
    width: 100%;
    background: #f4f5fa;
    .login-container {
        width: 80%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        position: relative;
        background: #f4f5fa;
        .login-left-bg {
            position: absolute;
            left: -40px;
            top: 50%;
            margin-top: -35vh;
            img {
                width: 50vw;
                height: 70vh;
            }
        }
    }
}
</style>
